import 'babel-polyfill';
import 'whatwg-fetch'
import './polyfill.nodelist.js';
import CustomEvent from "custom-event";
if (!window.CustomEvent || typeof window.CustomEvent !== "function") {
    window.CustomEvent = CustomEvent;
}